import { render, staticRenderFns } from "./EsclusioniFeed.vue?vue&type=template&id=43a12170&scoped=true"
import script from "./EsclusioniFeed.vue?vue&type=script&lang=js"
export * from "./EsclusioniFeed.vue?vue&type=script&lang=js"
import style0 from "./EsclusioniFeed.vue?vue&type=style&index=0&id=43a12170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a12170",
  null
  
)

export default component.exports